module.exports = __webpack_public_path__ + "img/es_es.b9f3db29.png";